export const MultilineText = ({ children, className, style, id }) => {
	return (
		<p id={id} style={{ whiteSpace: "pre-wrap", ...(style || {}) }} className={className}>
			{children}
		</p>
	)
}
